import LoginForm from "@/components/forms/LoginForm";
import { useLogin } from "@hooks/useLogin";
import { ThemeToggle } from "@/shared/components/ui/themeToggle";
import { useCurrentUser } from "@/features/login/hooks/useCurrentUser";
import { toast } from "sonner";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import logo from "@/assets/LOGO-RETRO-IA.png";

export function LoginPage() {
  const loginMutation = useLogin();
  const { setUser, user } = useCurrentUser();
  const navigate = useNavigate();

  const handleLogin = async (nombreUsuario: string, password: string) => {
    loginMutation.mutate(
      { nombreUsuario, password },
      {
        onSuccess: (data) => {
          setUser({
            id: data.id,
            nombreUsuario: data.nombreUsuario,
            nombre: data.nombre,
            apellidoPaterno: data.apellidoPaterno,
            apellidoMaterno: data.apellidoMaterno,
            correo: data.correo,
            ultimoAcceso: data.ultimoAcceso,
            rol: {
              id: data.rol.id,
              nombre: data.rol.nombre,
              descripcion: data.rol.descripcion,
            },
          });
          toast.success("¡Inicio de sesión exitoso!");
        },
        onError: (error) => {
          console.error("Error al iniciar sesión:", error);
          toast.error(
            "Error al iniciar sesión. Por favor, verifica tus credenciales.",
          );
        },
      },
    );
  };

  // Redirige según el rol cuando el usuario esté definido
  useEffect(() => {
    if (user && user.rol?.nombre) {
      switch (user.rol.nombre) {
        case "SUPER_ADMIN":
          navigate("/admin", { replace: true });
          break;
        case "INTERMEDIO":
          navigate("/intermediario", { replace: true });
          break;
        case "CLIENTE":
          navigate("/cliente", { replace: true });
          break;
        default:
          navigate("/", { replace: true });
      }
    }
  }, [user, navigate]);

  return (
    <div
      className="flex h-screen items-center justify-center bg-gradient-to-b"
      style={{
        backgroundImage:
          "linear-gradient(to bottom, var(--linear-gradient-start), var(--linear-gradient-end))",
      }}
    >
      <div className="absolute top-4 right-4">
        <ThemeToggle />
      </div>
      <div
        className="min-h-screen flex items-center justify-center px-3 sm:px-4 md:px-6 shadow-xl"
        style={{
          background: `radial-gradient(circle at top right, var(--linear-gradient-end), var(--linear-gradient-start) 40%)`,
        }}
      >
        <div className="min-h-screen w-full max-w-2xl flex items-start justify-center px-4 sm:px-8 md:px-12 lg:px-20 pt-[10vh]">
          <div className="flex flex-col w-full max-w-md">
            <div className="m-6 sm:m-8 md:m-10 flex justify-center">
              <img
                src={logo}
                alt="Logo Retro IA"
                className="h-auto w-40 sm:w-50"
              />
            </div>
            <LoginForm
              onSubmit={handleLogin}
              isLoading={loginMutation.isPending}
              error={
                loginMutation.isError
                  ? (loginMutation.error as Error).message
                  : null
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
}
